<template>
    <div class="background">
        <div
            class="text">
            暂无订单
        </div>
        <div class="loading-text">
            查询中, 订单来了会自动刷新...
        </div>
        <div
            v-on:click="sendRollbackClick"
            class="rollback-area">
            <a-icon
                class="logout-icon"
                type="undo" />
            <div class="rest-text">
                撤销上一单（10秒内）
            </div>
        </div>
        <div
            v-on:click="rest"
            class="rest-area">
            <a-icon
                class="rest-icon"
                type="rest" />
            <div class="rest-text">
                休息
            </div>
        </div>
        <div
            v-on:click="logout"
            class="logout-area">
            <a-icon
                class="logout-icon"
                type="logout" />
            <div class="logout-text">
                退出
            </div>
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';

 import EventBus from "../event/event-bus.js"
 import {sendRollback} from "@/util/order";
 
 export default {
     name: 'FetchingPage',
     props: {
     },
     components: {
     },
     methods: {
         logout() {
             this.$router.replace("/")
         },
         rest() {
             EventBus.$emit("restFromFetching")
         },
         sendRollbackClick() {
           console.log("sendRollbackClick2")
           sendRollback(this.$store.getters.orderId)
         },
     }
 }
</script>

<style scoped>
 .background {
     width: 100%;
     height: 100%;
     background-color: rgba(0, 0, 0, 0.8);

     position: fixed;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;

     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
 }

 .text {
     color: #FFF;
     font-size: 70px;
 }

 .loading-text {
     color: #FFF;
     font-size: 20px;
     margin-top: 20px;
 }

 .logout-area {
     position: fixed;
     top: 20px;
     right: 30px;

     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;

     color: #AAA;
     cursor: pointer;
     transition: all .2s ease-in;
 }

 .logout-area:hover {
     color: #FFF;
 }

 .logout-icon {
     font-size: 30px;
 }

 .logout-text {
     font-size: 14px;
     margin-top: 5px;
 }

 .rollback-area {
    position: fixed;
     top: 20px;
     right: 180px;

     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;

     color: #AAA;
     cursor: pointer;
     transition: all .2s ease-in;
 }

 .rollback-area:hover {
     color: #FFF;
 }

 .rest-area {
     position: fixed;
     top: 20px;
     right: 90px;

     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;

     color: #AAA;
     cursor: pointer;
     transition: all .2s ease-in;
 }

 .rest-area:hover {
     color: #FFF;
 }

 .rest-icon {
     font-size: 30px;
 }

 .rest-text {
     font-size: 14px;
     margin-top: 5px;
 }
</style>
